module.exports = __webpack_public_path__ + "static/img/在线问诊@2x2.94415ba5.png";